import logo from '../assets/images/logo.svg';
import star from '../assets/images/star.svg';
import card from '../assets/images/card.svg';
import arrow from '../../src/assets/images/arrow.svg';
import mailline from '../../src/assets/images/mailline.svg';
import facebook from '../../src/assets/images/facebook.svg';
import twiteer from '../../src/assets/images/twiteer.svg';
import instagram from '../../src/assets/images/instagram.svg';
import {Link, useLocation} from 'react-router-dom';
import mastercard from '../assets/images/mastercard.svg';
import visa from '../assets/images/visa.svg';
import stripeFooter from '../assets/images/stripe-footer.svg';
import payment1 from '../assets/images/payment1.svg';
import safepayment from '../assets/images/safepayment.svg';
import reviews1 from '../assets/images/reviews1.svg';
import youtube from '../assets/images/youtube.svg';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {API} from '../utils/api';
import {useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import './footer.css';
import {LazyLoadImage} from 'react-lazy-load-image-component';

const Footer = ({isNew}) => {
  const {pathname} = useLocation();
  // console.log("pathname ===== >", pathname);
  const [lodding, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Invalid email')
        .required('Please enter your email.')
        .matches(/@.*\./, 'Domain name is required'),
    }),

    onSubmit: (values) => {
      // Your login logic here using the form values
      // For example, you can authenticate the user and navigate upon successful login
      const {email} = values;

      setLoading(true);
      try {
        const body = {
          email: email,
        };

        console.log('body', body);

        API('subscribe/add-subscribe?type=1', 'post', body, '')
          .then((response) => {
            document.querySelector('body').scrollTo(0, 0);
            setLoading(false);
            setVisible(true);
            formik.resetForm();
            console.log('responce', response);
            setMessage(response?.data?.subscribe);
          })
          .catch((error) => {
            setLoading(false);
            // setVisible(true);
            console.log('catch error:', error);
          });
      } catch (error) {
        console.log('catch error message: ', error);

        setLoading(false);
      }
      // Perform authentication logic here...

      // For demonstration purposes, let's assume authentication is successful
      // Redirect the user to the home page
      // localStorage.setItem(constants.USER, email); // Storing user in localStorage
      // navigate('/');
    },
  });

  return (
    <>
      {
        <section className="reg__help--section d-flex w-100">
          <div className="reg__help--title col-4">
            <p className="f24 mb-0 fys text-700 text-center">
              We’re always happy to help.
            </p>
          </div>
          <div className="reg__help--contect d-flex justify-between col-7">
            <div className="reg__help--tm d-flex align-center">
              <div className="reg__tel d-flex align-top">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H11.04C11.3197 4.00021 11.5923 4.0884 11.8191 4.25207C12.046 4.41574 12.2156 4.64661 12.304 4.912L14.3013 10.9027C14.4025 11.2071 14.3906 11.5379 14.2676 11.8342C14.1447 12.1305 13.919 12.3726 13.632 12.516L10.6227 14.0227C12.0978 17.2874 14.7126 19.9022 17.9773 21.3773L19.484 18.368C19.6274 18.081 19.8695 17.8553 20.1658 17.7324C20.4621 17.6094 20.7929 17.5975 21.0973 17.6987L27.088 19.696C27.3536 19.7845 27.5846 19.9543 27.7483 20.1814C27.912 20.4085 28.0001 20.6814 28 20.9613V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H24C12.9547 28 4 19.0453 4 8V6.66667Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="teg__tel--text  fsi">
                  <span className="fsi f16 d-block lh20 blue-text ">Call:</span>
                  <a className="f20 lh28 fsi" href=" tel:01582347734 ">
                    01582 347734
                  </a>
                </div>
              </div>
              <div className="reg__tel d-flex align-top">
                <img className="in-svg" src={mailline} alt="img " />
                <div className="teg__tel--text fsi">
                  <span className="fsi f16 d-block lh20 blue-text ">
                    Email:
                  </span>
                  <a className="f20 lh28 fsi " href=" mailto:info@reg247.co.uk">
                    info@reg247.co.uk
                  </a>
                </div>
              </div>
            </div>
            <div className="reg__help--social">
              <span className="fsi f16 d-block lh20 blue-text ">
                Connect with us
              </span>
              <div className="reg__social--icon d-flex align-center">
                <a
                  className="facebook youtube"
                  href="https://www.youtube.com/@reg_247"
                  rel="noopener"
                  rel="noreferrer"
                  target="_blank">
                  <img className="in-svg " src={youtube} alt="img " />
                </a>
                <a
                  className="facebook"
                  href="https://www.facebook.com/reg247"
                  rel="noopener"
                  rel="noreferrer"
                  target="_blank">
                  <img className="in-svg " src={facebook} alt="img " />
                </a>
                <a
                  className="facebook"
                  href="https://twitter.com/reg_247"
                  rel="noopener"
                  rel="noreferrer"
                  target="_blank">
                  <img className="in-svg " src={twiteer} alt="img " />
                </a>
                <a
                  className="facebook"
                  href="https://www.instagram.com/reg_247/"
                  rel="noopener"
                  rel="noreferrer"
                  target="_blank">
                  <img className="in-svg " src={instagram} alt="img " />
                </a>
              </div>
            </div>
          </div>
        </section>
      }
      {
        <footer className="reg__footer text-white">
          <div className="container ">
            <div className="reg__dmo--section">
              <div className="row w-100 m-0">
                <div className={isNew ? 'col-12' : 'col-6'}>
                  <div className="reg__dm--text text-center text-white">
                    <p className="fys text-700 f36 mb-5">
                      Be the first to know!
                    </p>
                    <span className="fsi">
                      Sign up to our newsletter to be kept in the loop on all
                      our sales events, special offers and industry news. Never
                      miss a plate again.
                    </span>
                  </div>
                </div>
                {!isNew && (
                  <div className="col-6">
                    <form
                      className="reg__footer--form d-flex justify-between mb-23"
                      onSubmit={formik.handleSubmit}>
                      <input
                        className="form-control f-16 fsi"
                        type="search"
                        placeholder="Email Address"
                        aria-label="Search"
                        value={formik.values.email}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'email',
                            e.target.value?.trimStart(),
                          );
                        }}
                      />

                      <button
                        className="reg__search--button btn btn-outline-success green-section border-0 rounded-0"
                        type="submit">
                        SUBSCRIBE{' '}
                        <img
                          className="w-32 h-32 ml-10"
                          src={arrow}
                          alt="image"
                        />
                      </button>
                    </form>
                    <div className="text-center">
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="reg__partition"></div>
            <div className="reg__retting d-flex align-center justify-between mb-30">
              <div className="reg__logo">
                <img src={logo} alt="Logo image" />
              </div>
              <a
                href="https://www.reviews.co.uk/company-reviews/store/reg247.co.uk"
                rel="noopener"
                rel="noreferrer"
                target="_blank">
                <picture>
                  <source
                    type="image/png"
                    srcSet="https://s3-eu-west-1.amazonaws.com/reviews-global/images/trust-badges/reviews-trust-logo-3.png 1x, https://s3-eu-west-1.amazonaws.com/reviews-global/images/trust-badges/reviews-trust-logo-3@2x.png 2x"
                  />
                  <img
                    src="https://s3-eu-west-1.amazonaws.com/reviews-global/images/trust-badges/reviews-trust-logo-3.png"
                    alt="image"
                  />
                </picture>
              </a>
            </div>
            <div className="reg__help--data d-flex justify-between">
              <ul className="text-white">
                <li className="reg__footer--title fys mb-8 text-700 f20">
                  Sell
                </li>
                <li className="fsi f16 mb-8">
                  <Link to={'/sell-number-plate'}>List a Plate</Link>
                </li>
                <li className="fsi f16 mb-8">
                  <Link to={'/number-plate-valuation'}>Get a Valuation</Link>
                </li>
              </ul>
              {/* <ul className="text-white">
                  <li className="reg__footer--title fys mb-8 text-700 f20">
                    Services
                  </li>
                  <li className="fsi f16 mb-8">
                    <Link to={'/buy-number-plates'}>Plate Printing</Link>
                  </li>
                  <li className="fsi f16 mb-8">
                    <Link to={'/plate-viewer'}>Plate Viewer</Link>
                  </li>
                </ul> */}
              <ul className="text-white">
                <li className="reg__footer--title fys mb-8 text-700 f20">
                  Discover More
                </li>
                <li className="fsi f16 mb-8">
                  <Link to={'/about'}>About Us</Link>
                </li>
                <li className="fsi f16 mb-8">
                  <Link to={'/number-plate-news'}>Blog</Link>
                </li>
                <li className="fsi f16 mb-8">
                  <Link to={'/number-plate-faq'}>FAQs</Link>
                </li>
              </ul>
              <ul className="text-white">
                <li className="reg__footer--title fys mb-8 text-700 f20">
                  Terms & Privacy
                </li>
                <li className="fsi f16 mb-8">
                  <Link to={'/terms-and-conditions'}>Terms and Conditions</Link>
                </li>
                <li className="fsi f16 mb-8">
                  <Link to={'/privacy-policy'}>Privacy Policy</Link>
                </li>
              </ul>
            </div>
            <div className="reg__partition"></div>
            <div className="reg__term d-flex align-center justify-between">
              <div className="reg__term-data d-flex align-center text-white fsi">
                <span className="f16 pr-21 right-line">
                  © {new Date().getFullYear()} REG247 Company Number: 15111508,
                  VAT: 456773649
                </span>
                <Link
                  className="f16 pr-21 right-line"
                  to={'/terms-and-conditions'}
                  rel="noopener"
                  rel="noreferrer"
                  target="_blank"
                  rel="noopener noreferrer">
                  Terms and Conditions
                </Link>
                <Link
                  className="f16"
                  to={'/privacy-policy'}
                  rel="noopener"
                  rel="noreferrer"
                  target="_blank"
                  rel="noopener noreferrer">
                  Privacy Policy
                </Link>
              </div>
              <div className="reg__payment--data">
                <div className="payment__image">
                  <img src={mastercard} alt="image" />
                </div>
                <div className="payment__image">
                  <img src={visa} alt="image" />
                </div>
                {/* <div className="payment__image">
                  <img src={payment1} />
                </div>
                <div className="payment__image">
                  <img src={safepayment} />
                </div> */}
                <div className="payment__image">
                  <a
                    rel="noopener"
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.reviews.io/company-reviews/store/reg247.co.uk">
                    <img src={reviews1} alt="image" />
                  </a>
                </div>
                <div className="payment__image">
                  <img src={stripeFooter} alt="image" />
                </div>
              </div>
            </div>
            <div className="reg__partition"></div>
            <p className="fsi f12 mb-0 text-center">
              DVLA is a registered trade mark of the Driver & Vehicle Licensing
              Agency. REG247 is not affiliated to the DVLA or DVLA Personalised
              Registrations. REG247 is a recognised reseller of DVLA
              registrations. <br />
              <br />
              Website design and development by{' '}
              <span className="fsi f12 mb-0 text-center ">
                {' '}
                <a
                  style={{fontSize: 12}}
                  href="https://www.duenorth.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer">
                  Due North
                </a>
              </span>
            </p>
          </div>
        </footer>
      }

      <Modal show={visible} onHide={() => setVisible(false)}>
        <div className=" alert__box  ">
          <label>{message}</label>
          <button className="alert__btn" onClick={() => setVisible(false)}>
            X
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Footer;
